import { Card } from "@/components/ui/card";
import { getThumbnailUrl } from "@talentir/shared/helpers";
import Image from "next/image";

type Token = {
    title: string;
    contentId: string;
    thumbnail: string;
    talentId: string;
    talentUsername: string | null;
};

export function TokenModalInfo({ token }: { token: Token }) {
    function truncateString(value: string) {
        if (value.length > 50) {
            return `${value.substring(0, 50)}...`;
        }
        return value;
    }

    return (
        <Card className="flex p-3">
            <div className="flex items-center">
                <Image
                    src={getThumbnailUrl(token.thumbnail)}
                    alt="thumbnail"
                    width={80}
                    height={45}
                    className="mr-3 rounded object-cover"
                />
            </div>
            <div className="flex flex-col justify-center">
                <div className="font-bold text-xs">{truncateString(token.title)}</div>
                <div className="text-muted-foreground text-xs">{token.talentUsername}</div>
            </div>
        </Card>
    );
}
